export default __webpack_public_path__ + "static/media/Jost-Bold.ac698185.ttf";